import React from 'react';

const Start = React.lazy(() => import('pages/orders/self-checkout/steps/start'));
const ProductList = React.lazy(() => import('pages/orders/self-checkout/steps/product-list'));
const Customer = React.lazy(() => import('pages/orders/self-checkout/steps/customer'));
const Tip = React.lazy(() => import('pages/orders/self-checkout/steps/tip'));
const Checkout = React.lazy(() => import('pages/orders/self-checkout/steps/checkout'));

export const definitions = [
  {
    index: true,
    path: '',
    component: <Start />
  },
  {
    path: 'products',
    component: <ProductList />
  },
  {
    path: 'customer',
    component: <Customer />
  },
  {
    path: 'tip',
    component: <Tip />
  },
  {
    path: 'checkout',
    component: <Checkout />
  }
];
